module.exports = __webpack_public_path__ + "static/media/sophie-carousel.866fb0f5.png";